// extracted by mini-css-extract-plugin
module.exports = {"dots":"DonationPromptDots_dots__Xuhb5","dot":"DonationPromptDots_dot__8yIHB","dotActive":"DonationPromptDots_dotActive__nKGJD"};